module.exports = __webpack_public_path__ + "img/Cuidando tus Bienes.1766b766.svg";